<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  align: {
    type: String,
    default: 'center',
    validator: value => ['start', 'center', 'end'].includes(value),
  },
  side: {
    type: String,
    default: 'top',
    validator: value => ['top', 'bottom'].includes(value),
  },
});

const alignmentClass = computed(() => ({
  'left-0': props.align === 'start',
  'left-1/2 -translate-x-1/2': props.align === 'center',
  'right-0': props.align === 'end',
}));

const sideClass = computed(() => ({
  'bottom-full mb-2': props.side === 'top',
  'top-full mt-2': props.side === 'bottom',
}));
</script>

<template>
  <span class="group relative inline-flex">
    <slot />
    <span
      role="tooltip"
      class="pointer-events-none absolute z-[60] max-w-60 whitespace-nowrap rounded bg-n-slate-12 px-2 py-1 text-xs font-medium tracking-normal text-n-slate-1 opacity-0 shadow-md transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
      :class="[alignmentClass, sideClass]"
    >
      {{ label }}
    </span>
  </span>
</template>
